
function ArrowCircleLeft(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Livello 1"
      viewBox="0 0 128 128"
      width={18}
      height={18}
      {...props}
    >
      <path
        fill="#fff"
        d="M64 0a64 64 0 1064 64A64.07 64.07 0 0064 0zm0 122a58 58 0 1158-58 58.07 58.07 0 01-58 58z"
      ></path>
      <path
        fill="#fff"
        d="M74.12 35.88a3 3 0 00-4.24 0l-26 26a3 3 0 000 4.24l26 26a3 3 0 004.24-4.24L50.24 64l23.88-23.88a3 3 0 000-4.24z"
      ></path>
    </svg>
  );
}

export default ArrowCircleLeft;
